<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
      require: false,
    },
  },
  data() {
    return {
      collapse: true,
    }
  },
}
</script>

<template>
  <CCard class="shadow-sm">
    <CCardHeader
      :class="{
        'card-detail-header': true,
        'd-flex justify-content-between align-items-center p3': true,
      }"
    >
      <h3 class="font-weight-bold mb-0">
        {{ title || $route.meta.label }}
      </h3>
      <div>
        <slot name="header-action"> </slot>
        <CButton variant="ghost" @click="collapse = !collapse">
          <simple-line-icons v-if="collapse" icon="arrow-up" no-svg />
          <simple-line-icons v-else icon="arrow-down" no-svg />
        </CButton>
      </div>
    </CCardHeader>
    <CCollapse :show="collapse">
      <CCardBody>
        <slot></slot>
      </CCardBody>
    </CCollapse>
  </CCard>
</template>

<style lang="scss" scoped>
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: #f9f4ec;
  border-bottom: 1px solid #c8ced3;

  > h3 {
    display: inline-block;
    margin-bottom: 0;
    font-size: 1rem;
    font-weight: 700;
    line-height: 28px;
    color: $gray-600;
  }
}
</style>
